import {hoistCmp} from '@xh/hoist/core';
import {creates} from '@xh/hoist/core';
import { ChartsTabModel } from './ChartsTabModel';
import { panel } from '@xh/hoist/desktop/cmp/panel';
import { dashContainer } from '@xh/hoist/desktop/cmp/dash';
import './ChartsTab.scss';

export const chartsTab = hoistCmp.factory<ChartsTabModel>({
    model: creates(ChartsTabModel),
    render({model}) {
        return panel(dashContainer());
    }
});